var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldFormatSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 7.5c1.19-.5 2-1.67 2-3 0-1.79-1.46-3.25-3.25-3.25-1.32 0-2.5.81-3 2h-9c-.5-1.19-1.67-2-3-2-1.79 0-3.25 1.46-3.25 3.25 0 1.32.81 2.5 2 3v9c-1.19.5-2 1.67-2 3 0 1.79 1.46 3.25 3.25 3.25 1.32 0 2.5-.81 3-2h9c.5 1.19 1.67 2 3 2 1.79 0 3.25-1.46 3.25-3.25 0-1.32-.81-2.5-2-3v-9zm-1.91 8.82c-.27.05-.53.14-.78.27-.06.03-.12.06-.18.1-.5.28-.91.69-1.19 1.19-.04.06-.07.12-.1.18-.13.25-.22.51-.27.78-.02.11-.04.21-.05.32-.01.03-.01.06-.01.09H7.74a3.4 3.4 0 0 0-.14-.72c-.02-.08-.05-.17-.09-.25-.03-.07-.06-.14-.1-.22-.03-.06-.06-.12-.1-.18-.28-.5-.69-.91-1.19-1.19-.06-.04-.12-.07-.18-.1-.08-.04-.15-.07-.22-.1-.08-.04-.17-.07-.25-.09a3.4 3.4 0 0 0-.72-.14V7.74c.26-.02.5-.07.74-.15.09-.02.19-.06.28-.1.05-.02.11-.05.17-.08.06-.03.12-.06.18-.1.5-.28.91-.69 1.19-1.19.04-.06.07-.12.1-.18s.06-.12.08-.17c.04-.09.08-.19.1-.28.08-.24.13-.48.15-.74h8.52c.02.27.07.52.16.77.02.08.05.17.09.25.02.06.05.11.08.17.03.06.06.12.1.18.28.5.69.91 1.19 1.19.06.04.12.07.18.1s.11.06.17.08c.08.04.17.07.25.09.25.09.5.14.77.16v8.52c-.03 0-.06 0-.09.01-.11.01-.21.03-.32.05z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldFormatSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-format-square.5e02dde342c40a4afb1085889a172253.svg";
export { ForwardRef as ReactComponent };